var React = require('react');

function IntroPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M285.157 164.202L318.939 122.005L338.592 172.359L285.157 164.202Z","fill":"#C99CEF","key":0}),React.createElement("path",{"d":"M63.5709 42.9104L163.276 66.9598L92.5963 141.283L63.5709 42.9104Z","stroke":"#B1F8FC","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M331.367 239.573L320.951 241.892L324.151 231.711L331.367 239.573Z","stroke":"#FF5A7D","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M8.435 216.507L44.3396 211.12L31.0525 244.908L8.435 216.507Z","fill":"#B1F8FC","key":3}),React.createElement("path",{"d":"M204.664 229.697L200.426 220.437L210.564 221.397L204.664 229.697Z","fill":"white","key":4})]);
}

IntroPolyclusterInline.defaultProps = {"width":"355","height":"252","viewBox":"0 0 355 252","fill":"none"};

module.exports = IntroPolyclusterInline;

IntroPolyclusterInline.default = IntroPolyclusterInline;
